import ActorGraphs from './ActorGraphs';

export default ActorGraphs;
